export default {
  getProcedures: state => {
    if (state.procedures.data) {
      return state.procedures.data;
    }
    return [];
  }
};
